import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CreditCard } from "lucide-react";
import api from "@/lib/api";

const datum = (iso) => (iso ? new Date(iso).toLocaleDateString("de-DE") : "");

// Hinweis-Balken im App-Kopf: Testphase, abgelaufen (nur lesen) oder Zahlung fehlgeschlagen.
export default function BillingBanner({ isAdmin }) {
  const [s, setS] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!navigator.onLine) return;
    api.get("/billing/status").then((r) => setS(r.data)).catch(() => {});
  }, [pathname]);
  if (!s || s.betreiber) return null;
  let text = null;
  let tone = "bg-amber-50 text-amber-900 border-amber-200";
  if (s.zahlung_offen) { text = "Zahlung fehlgeschlagen – Zahlungsart aktualisieren"; tone = "bg-red-50 text-red-800 border-red-200"; }
  else if (s.nur_lesen) { text = "Testphase beendet – Tarif wählen, um weiterzuarbeiten"; tone = "bg-red-50 text-red-800 border-red-200"; }
  else if (s.plan === "test") text = `Testphase bis ${datum(s.test_endet)} – Tarif wählen`;
  if (!text) return null;
  const inner = <><CreditCard className="h-4 w-4 shrink-0" /><span>{text}{!isAdmin && " (bitte Administrator informieren)"}</span></>;
  return (
    <div className={`border-t ${tone}`} data-testid="billing-banner">
      <div className="max-w-[1400px] mx-auto px-4 py-1.5 text-sm font-medium">
        {isAdmin
          ? <Link to="/einstellungen/abo" className="flex items-center gap-2 hover:underline" data-testid="billing-banner-link">{inner}</Link>
          : <div className="flex items-center gap-2">{inner}</div>}
      </div>
    </div>
  );
}
